import cs from '../../mixins/contentstack-mixin';

export default {
  mixins: [cs],
  data() {
    return {
      cs: {
        entryID: '',
        title: '',
        banner_image: {
          url: '' },
        sub_heading: '',
        article_body: '',
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/common/contentstack/cs-article/cs-article.js